import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ContactVcard } from 'app/oDres/modelos/Generales/contactVcard';
import { ImageTransform } from 'ngx-image-cropper';

@Component({
  selector: 'app-vcard-generator',
  templateUrl: './vcard-generator.component.html',
  styleUrls: ['./vcard-generator.component.scss']
})
export class VcardGeneratorComponent implements OnInit {

  vcardInfo: ContactVcard = {
    firstName: null,
    lastName: null, 
    formattedName: null,
    organization: null,
    organizationPosition: null,
    title: null,
    photo: null,
    links: [],
    emails: [],
    phones: [],
    addresses: []
  };

  imageChangedEvent: any = '';
  fileName = '';
  croppedImage: any = '';
  canvasRotation = 0;
  transform: ImageTransform = {};
  rotation = 0;
  scale = 1;

  constructor(private modalService: NgbModal) { }

  ngOnInit(): void {
  }

  editarFotoVCard(content) {

    this.modalService.open(content, { backdrop: 'static', windowClass: 'editarAvatar', centered: true });

  }

  cancelarGuardarFoto() {

    this.croppedImage = '';
    this.modalService.dismissAll();
  }

  getFile(event: any) {
    //console.log('file: ', event.target.files[0]);

    this.fileName = event.target.files[0].name;
    this.imageChangedEvent = event;
  }

  rotateLeft() {
    this.canvasRotation--;
    this.flipAfterRotate();
  }

  rotateRight() {
    this.canvasRotation++;
    this.flipAfterRotate();
  }

  private flipAfterRotate() {
    const flippedH = this.transform.flipH;
    const flippedV = this.transform.flipV;
    this.transform = {
      ...this.transform,
      flipH: flippedV,
      flipV: flippedH
    };
  }

  flipHorizontal() {
    this.transform = {
      ...this.transform,
      flipH: !this.transform.flipH
    };
  }

  flipVertical() {
    this.transform = {
      ...this.transform,
      flipV: !this.transform.flipV
    };
  }

  updateRotation() {
    this.transform = {
      ...this.transform,
      rotate: this.rotation
    };
  }

  zoomOut() {
    this.scale -= .1;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

  zoomIn() {
    this.scale += .1;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

  revisarRotation() {
    //console.log(this.rotation);

    if (this.rotation == undefined || this.rotation == null) {
      this.rotation = 0;
    }
  }

  zoomChange() {
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

  revisarZoom() {
    //console.log(this.scale);

    if (this.scale == undefined || this.scale == null) {
      this.scale = 1;
    }
  }

}
